/*
 * File: /src/helpers/store-default-metafields-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:03:39 pm
 * Last Modified: Thu Oct 03 2019
 * Last Modified by: Bart
 * -
 * @author: Bart
 */

/**
 * field: {
 *  label,
 *  key,
 *  keyPrefix,
 *  keySuffix,
 *  description,
 *  type,
 * }
 */
import { pushMinRepeaterInstances, logger } from '@/helpers'

const DEFAULT_NAMESPACE = process.env.META_NAMESPACE

const DEFAULT_STATE = () => ({
    id: null,
    metafields: [],
    item: {}
})

const DEFAULT_ACTIONS = {
    async GET_METAFIELDS({ state, commit, dispatch }) {
        let key = state.key ? `?key=${state.key}` : ''
        let params = {
            endpoint: `metafields/${state.scope}/${state.id}${key}`
        }

        try {
            const { metafields } = await dispatch('shopifyApi/REQUEST', params, { root: true })

            return { metafields }
        } catch (error) {
            console.error(`GET_METAFIELDS_${state.scope}`, error)
            throw error
        }
    },

    async SAVE_METAFIELDS({ state, commit, dispatch }, payload = state.metafields) {
        let key = state.key ? `?key=${state.key}` : ''
        let params = {
            method: 'POST',
            endpoint:
                state.scope === 'globals'
                    ? `metafields/${state.scope}/0${key}`
                    : `metafields/${state.scope}/${state.id}${key}`,
            data: { metafields: payload, key: state.key || null }
        }

        try {
            await dispatch('shopifyApi/REQUEST', params, { root: true })
        } catch (error) {
            console.error(`SAVE_METAFIELDS ${state.scope}`, error)
            throw error
        }
    },

    async GET_ITEM({ state, commit, dispatch }, { id, collectionType }) {
        const query = collectionType ? `?collectionType=${collectionType}` : ''
        const endpoint = `items/${state.scope}/${id}${query}`

        try {
            const { item } = await dispatch(`shopifyApi/REQUEST`, { endpoint }, { root: true })

            commit('SET_ITEM', item)
        } catch (error) {
            console.error(`GET_ITEM${state.scope}`, error)
        }
    }
}

const DEFAULT_MUTATIONS = {
    SET_METAFIELDS(state, { metafields, isRefetch }) {
        // When isRefetch after save we dont need to pushMinRepeaterInstances
        const data = isRefetch ? pushMinRepeaterInstances(metafields) : metafields
        state.metafields = data

        logger(`store-default-metafields-helper.js / SET_METAFIELDS ${data}`, 'DEV')
    },

    SET_ID(state, { id }) {
        state.id = id
    },

    SET_ITEM(state, item) {
        state.item = item || {}
    }
}

const DEFAULT_GETTERS = {
    id: state => state.id,
    metafields: state => state.metafields,
    scope: state => state.scope,
    item: state => state.item
}

export const buildState = ({ state }) => Object.assign({}, DEFAULT_STATE(), state)
export const buildActions = ({ actions }) => Object.assign({}, DEFAULT_ACTIONS, actions)
export const buildMutations = ({ mutations }) => Object.assign({}, DEFAULT_MUTATIONS, mutations)
export const buildGetters = ({ getters }) => Object.assign({}, DEFAULT_GETTERS, getters)



// WEBPACK FOOTER //
// ./src/helpers/store-default-metafields-helper.js